<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" :title="'Notulen : '+title">
            <br>
            <common-training-header :withUser="true"/>
        </a-page-header>

        <a-card type="inner" size="small">
            <a-table
                class="pcp-table"
                :columns="columns"
                :dataSource="data"
                :loading="loading"
                :pagination="false" bordered>

                <div slot="name" slot-scope="record">
                    <strong>{{ record.title }}</strong>
                </div>

                <div slot="dot" slot-scope="record">
                    :
                </div>

                <div slot="description" slot-scope="record">
                    {{ record.description }}
                </div>
            </a-table>

            <a-table
                class="pcp-table"
                :columns="columnsSecond"
                :dataSource="data_second"
                :loading="loading"
                :pagination="false" bordered
                style="margin-top: 12px">

                <div slot="name" slot-scope="record">
                    <strong>{{ record.title }}</strong>
                </div>

                <div slot="dot" slot-scope="record">
                    :
                </div>

                <div slot="description" slot-scope="record">
                    {{ record.description }}
                </div>
            </a-table>
        </a-card>
    </div>
</template>

<script>
    const columns = [
        {
            key: 'name',
            title: 'INFORMASI',
            colSpan: 3,
            width: '200px',
            scopedSlots: {customRender: 'name'},
        }, {
            key: 'dot',
            title: '',
            colSpan: 0,
            width: '5px',
            scopedSlots: {customRender: 'dot'},
        }, {
            key: 'description',
            title: '',
            colSpan: 0,
            scopedSlots: {customRender: 'description'}
        },
    ]

    const columnsSecond = [
        {
            key: 'name',
            title: 'PELAKSANAAN',
            colSpan: 3,
            width: '200px',
            scopedSlots: {customRender: 'name'},
        }, {
            key: 'dot',
            title: '',
            colSpan: 0,
            width: '5px',
            scopedSlots: {customRender: 'dot'},
        }, {
            key: 'description',
            title: '',
            colSpan: 0,
            scopedSlots: {customRender: 'description'}
        },
    ]

    export default {
        props: {
            outline: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                columns,
                columnsSecond,
                items: {
                    notulens: [],
                },
                loading: false,
                data: [
                    {
                        key: '1',
                        title: 'Group',
                        description: null
                    },
                    {
                        key: '2',
                        title: 'Lokasi Ujian',
                        description: null
                    },
                    {
                        key: '3',
                        title: 'Waktu Pelaksanaan',
                        description: null
                    },
                    {
                        key: '4',
                        title: 'Penguji',
                        description: null
                    }
                ],
                data_second: [
                    {
                        key: '1',
                        title: 'Nama Peserta',
                        description: null
                    },
                    {
                        key: '2',
                        title: 'Judul Project',
                        description: null
                    },
                    {
                        key: '3',
                        title: 'Waktu Presentasi',
                        description: null
                    },
                    {
                        key: '4',
                        title: 'Keterangan',
                        description: null
                    },
                    {
                        key: '5',
                        title: 'Uraian',
                        description: null
                    }
                ],
            }
        },
        created() {
            console.log(this.title)
            this.getItems()
        },
        methods: {
            getItems() {
                this.loading = true;

                let params = {}

                if(this.outline != 'paper' && this.outline != 'evaluation'){
                    params = {
                        outline: this.outline,
                    }
                }

                this.$http
                    .get(this.routeUri("api.activity-notulens") + '?' + this.$qs.stringify(params))
                    .then(response => this.items = response.data)
                    .catch(error => this.handleXhrError(error))
                    .finally(() => (this.loading = false));
            },
        },
        computed: {
            activeModule() {
                return this.$laravel.active_module
            }
        },
        watch: {
            items: function(value) {
                if(value.notulens.length > 0){
                    this.data[0].description = value.notulens[0].group
                    this.data[1].description = value.notulens[0].presentation_location
                    this.data[2].description = value.notulens[0].exam_time
                    this.data[3].description = value.notulens[0].tester

                    this.data_second[0].description = value.notulens[0].attendant
                    this.data_second[1].description = value.notulens[0].title_project
                    this.data_second[2].description = value.notulens[0].presentation_time
                    this.data_second[3].description = value.notulens[0].description
                    this.data_second[4].description = value.notulens[0].note
                }
            }
        }
    }
</script>
